import { render, staticRenderFns } from "./lookApply.vue?vue&type=template&id=8957d62a&scoped=true&"
import script from "./lookApply.vue?vue&type=script&lang=js&"
export * from "./lookApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8957d62a",
  null
  
)

export default component.exports